import { apiClient } from '../lib/api';
import { buildApiUrl } from '../utils/apiUrl';
import { ProvinceBoundarySchema } from '../schemas/provinceBoundary';
import type { GeoJSON } from './geoJsonApi';

export type { ProvinceBoundaryFeature, ProvinceBoundaryFeatureCollection } from '../schemas/provinceBoundary';
export { ProvinceBoundaryFeatureSchema, ProvinceBoundarySchema } from '../schemas/provinceBoundary';

type Ban = 'goc' | 'hien-hanh';

async function fetchBoundaries(ban: Ban): Promise<GeoJSON> {
	const params = new URLSearchParams({ ban });
	const url = buildApiUrl('/provinces/boundaries', params);
	const response = await apiClient.get<unknown>(url);
	return ProvinceBoundarySchema.parse(response.data) as GeoJSON;
}

export const provinceBoundaryApi = {
	/** `ban=hien-hanh` — boundaries resolved through the current province-code lineage. */
	getCurrent: (): Promise<GeoJSON> => fetchBoundaries('hien-hanh'),
	/** `ban=goc` — the immutable 63-province base boundaries. */
	getBase: (): Promise<GeoJSON> => fetchBoundaries('goc'),
};
